import { Injectable, InjectionToken } from "@angular/core";
import { TechGroupFeatureListGetQuery, TechGroupFeatureListGetQueryResult, TechGroupFeatureRegisterListGetQuery, TechGroupFeatureRegisterListGetQueryResult, TechGroupGetQuery, TechGroupGetQueryResult } from "../../INTEGRA_Shop_Client";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export abstract class ITechGroupApiService {
  abstract swagTechGroupGetAsync(query: TechGroupGetQuery): Promise<TechGroupGetQueryResult>;

  abstract swagTechGroupFeatureListGet(query: TechGroupFeatureListGetQuery): Observable<TechGroupFeatureListGetQueryResult>;

  abstract swagTechGroupFeatureRegisterListGet(query: TechGroupFeatureRegisterListGetQuery): Observable<TechGroupFeatureRegisterListGetQueryResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ITechGroupApiServiceToken = new InjectionToken<ITechGroupApiService>('ITechGroupApiServiceToken');
